import React from 'react';
import gql from 'graphql-tag';
import { graphql, ChildProps } from 'react-apollo';
import { CorePacklinkAccountStatus, core_apimessages_PacklinkAccount_Status as AccountStatus } from '../schemas/rql';
import { RCLoadingBars } from '@reverbdotcom/commons/src/rc/RCLoadingBars';

interface ExternalProps {
  onStatusUpdate(status: AccountStatus): void;
}

type Props = ChildProps<ExternalProps, CorePacklinkAccountStatus.Query>;

export function PacklinkAccountStatus(props: Props) {
  const status = props.data?.me?.shop?.packlink?.account?.status;

  useStatusUpdate(status, props.onStatusUpdate);

  return <RCLoadingBars />;
}

export function useStatusUpdate(status: AccountStatus, updateStatus?: (status: AccountStatus) => void) {
  React.useEffect(() => {
    updateStatus(status);
  }, [status, updateStatus]);
}

const withQuery = graphql<ExternalProps, {}>(
  gql`
  query Core_Packlink_AccountStatus {
    me {
      uuid
      shop {
        _id
        packlink {
          account {
            email
            status
          }
        }
      }
    }
  }`,
  {
    options: {
      fetchPolicy: 'network-only',
      pollInterval: 500,
    },
  },
);

export default withQuery(PacklinkAccountStatus);
